import { Directive, EventEmitter, Output, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[outsideClick]',
  standalone: false
})
export class OutsideClickDirective {
  @Output()
  public outsideClick = new EventEmitter<MouseEvent>();

  constructor(private readonly elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public onClick(e: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(e.target)) {
      this.outsideClick.emit(e);
    }
  }
}
